
// // @flow
// import { Component, OnInit } from '@angular/core';
// import Swal from 'sweetalert2';
// import { HttpClient } from '@angular/common/http';
// import {Subscription} from 'rxjs';

// @Component({
//     selector: 'cu-download-link-cell-renderer',
//     template: `
//     <div class="text-center">
//       <i class="fa {{params.icon}}" (click)="onClick()" aria-hidden="true"></i>
//     </div>`
//   })
//   export class ActionCellRendererComponent {

//     static parameters = [HttpClient];
  
//       params;
  
//       constructor(private http: HttpClient) {
//         this.http = http;
//       }
  
//       agInit(params): void {
//           this.params = params;
//         //   if (_.isNil(params.action)) {
//         //       throw new Error('Missing action parameter for ActionCellRendererComponent');
//         //  }
//      }
  
//      onClick(): void {
//          this.params.action(this.params);
//        //   console.log("entered", this.params);
//         //  Swal({
//         //     title: 'Delete',
//         //     text: "Are you sure you want to delete bin",
//         //     type: 'warning',
//         //     showCancelButton: true,
//         //     confirmButtonColor: '#3085d6',
//         //     cancelButtonColor: '#d33',
//         //     confirmButtonText: 'Confirm',
//         //     customClass: 'swal-warning-custom'
//         // }).then(result => {
//         //     if (result.value) {
//         //       //   console.log("result is true");
//         //         this.deleteBin(this.params.data);
//         //     }
//         //     return;
//         // });
//      }

//      deleteBin(data) {
//       //   console.log("data", data);
//         this.http.post('/api/bins/deleteBinByID', data)
//                 .subscribe(response => {
//                     if (response[0].flag == 1) {
//                         Swal({
//                             title: response[0].msg,
//                             type: 'success'
//                         })
//                     }
//                     if (response[0].flag == 2 || response[0].flag == 0) {
//                         Swal({
//                             title: response[0].msg,
//                             type: 'error'
//                         })
//                     }
//                 });
//      }
//   }
  
//   export type CellAction = (params) => void;


// Author: T4professor

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
// import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid';

@Component({
  selector: 'app-button-renderer',
  template: `
    <div class="text-center">
      <i class="fa {{params.icon}}" (click)="onClick()" aria-hidden="true"></i>
    </div>
    `
})

export class ButtonRendererComponent implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.onClick(params);

    }
  }
}